import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseComponent } from '@macs-frontend/core';
import { makeSelectable, Select } from '@macs-frontend/decorators';
import { Store } from '@ngrx/store';
import { FormGroupState } from 'ngrx-forms';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as authActions from '../../actions/auth.actions';
import { ResetPasswordPayload } from '../../models/reset-password.model';
import * as fromAuth from '../../reducers/index';

@Component({
  selector: 'md-reset-password',
  templateUrl: './reset-password.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResetPasswordComponent extends BaseComponent {
  @Select(fromAuth.getResetPasswordForm)
  // @ts-expect-error
  resetPasswordForm$: Observable<FormGroupState<fromAuth.ResetPasswordForm>>;

  // @ts-expect-error
  resetPasswordPayload: ResetPasswordPayload;

  constructor(
    readonly store$: Store<fromAuth.AuthState>,
    route: ActivatedRoute,
    readonly cdr: ChangeDetectorRef,
  ) {
    super();
    makeSelectable(this, { cdr, store$ });
    route.params.pipe(takeUntil(this.destroy$)).subscribe(params => {
      this.resetPasswordPayload = {
        username: params.username,
        token: params.token,
      };
      this.store$.dispatch(new authActions.ValidateResetLink(this.resetPasswordPayload));
    });
  }

  resetPassword() {
    this.store$.dispatch(new authActions.ResetPassword(this.resetPasswordPayload));
  }
}
